import Bars from "./Bars/Bars";
import { scaleOrdinal } from "d3";
import MapSection from "./Map/MapSection";
import SummarySection from "./Summary/SummarySection";

const BodyMain = (props) => {
  const mapSectionWidth = props.width * 0.55;
  const summarySectionWidth = props.width - mapSectionWidth;
  const barsHeight = props.height * 0.108;
  const mapSummaryHeight = props.height - barsHeight;

  const colours = ["#C95200", "#898989", "#0D657D", "#FAA61A"];
  const eventTypes = [
    "Violence against civilians",
    "Riots",
    "Explosions/Remote violence",
    "Battles",
  ];
  const colourScale = scaleOrdinal().domain(eventTypes).range(colours);

  return (
    <div
      id="bodyContainer"
      className="container"
      style={{
        height: props.height,
        width: props.width,
        margin: "auto",
        background: "#d7d7d7",
      }}
    >
      <Bars
        height={barsHeight}
        width={props.width}
        colours={colours}
        eventTypes={eventTypes}
        colourScale={colourScale}
      />
      <div
        id="mapSummary"
        style={{ height: mapSummaryHeight, display: "flex" }}
      >
        <MapSection
          width={mapSectionWidth}
          focusCountry={props.focusCountry}
          height={mapSummaryHeight}
          colours={colours}
          eventTypes={eventTypes}
          colourScale={colourScale}
        />
        <SummarySection width={summarySectionWidth} height={mapSummaryHeight}
        focusCountry={props.focusCountry} />
      </div>
    </div>
  );
};

export default BodyMain;
